import request from '@/request'

export async function getInvoice (id) {
  const response = await request({
    url: `/invoices/${id}`,
    method: 'get'
  })

  return response.data.data
}

export async function getInvoiceStatus (id) {
  const response = await request({
    url: `/invoices/${id}/status`,
    method: 'get'
  })

  return response.data.data
}